import { render, staticRenderFns } from "./markdownsale.vue?vue&type=template&id=f920ded4&"
import script from "./markdownsale.vue?vue&type=script&lang=js&"
export * from "./markdownsale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports